import * as actionTypes from "../Constants/AccountActionTypes";

const initialState = {
  details: {
    address: {}
  },
};

const account = (state = initialState, { type, payload }) => {
  switch (type) {

    case actionTypes.UPDATE_USER_ACCOUNT:
      return { ...payload };

    case actionTypes.SET_USER_ACCOUNT:
      let number;
      if (payload.details && payload.details.contactNumbers) {
        const found = payload.details.contactNumbers.find(({ isDefault }) => isDefault);
        if (found) number = found.number;
      }
      return { ...state, ...payload, details: { ...state.details, ...payload.details, number } };

    default:
      return state;
  }
}

export default account;